import { createFileRoute, redirect } from "@tanstack/react-router";

// Portal's `_protected.admin._index` — redirect the admin root to the dashboard.
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/admin/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/admin/dashboard",
      params: { locale: params.locale, schoolyear: params.schoolyear },
    });
  },
});
